module.exports = __webpack_public_path__ + "img/lisen-5.7bf56822.jpg";